import { ShopOutlined, TeamOutlined } from '@ant-design/icons'
import { useEffect } from 'react'

import AtomSwitch from '@/components/Atoms/AtomSwitch/AtomSwitch'
import { SCENARIOS } from '@/constants'
import { useProfileStore } from '@/stores/user/profileStore'
import { useUserInfoStore } from '@/stores/user/userInfoStore'
import { isSupplierStaff } from '@/utils/auth/userRoles'

import Orders from './Orders/Orders'
import cn from './Profile.module.scss'

const CLIENT_ORDERS_TAB = 'Заказы клиентов'
const SUPPLIER_ORDERS_TAB = 'Заказы поставщикам'

function Profile() {
  const { currentTab, setCurrentTab, setInitialProfileStore } =
    useProfileStore()
  const scenario = useUserInfoStore((state) => state.scenario)
  const isStaff = useUserInfoStore((state) => isSupplierStaff(state.tokenRoles))
  const isOrganisationSelected = useUserInfoStore(
    (state) => Object.keys(state.selectedOrganisation).length > 0
  )

  const isClientSelectionPending =
    scenario === SCENARIOS.CLIENT_SELECTION_PENDING

  useEffect(() => {
    setInitialProfileStore()
  }, [])

  const availableTabs = isStaff
    ? [CLIENT_ORDERS_TAB, SUPPLIER_ORDERS_TAB]
    : [CLIENT_ORDERS_TAB]

  const clientOrdersOption = {
    value: CLIENT_ORDERS_TAB,
    label: CLIENT_ORDERS_TAB,
    icon: <TeamOutlined aria-hidden />,
  }
  const supplierOrdersOption = {
    value: SUPPLIER_ORDERS_TAB,
    label: SUPPLIER_ORDERS_TAB,
    icon: <ShopOutlined aria-hidden />,
  }
  const tabOptions = isClientSelectionPending
    ? [supplierOrdersOption]
    : isStaff
      ? [clientOrdersOption, supplierOrdersOption]
      : [clientOrdersOption]

  const displayTab = availableTabs.includes(currentTab)
    ? currentTab
    : CLIENT_ORDERS_TAB

  const getOrderType = (): 'CLIENT' | 'SUPPLIER' | null => {
    if (displayTab === CLIENT_ORDERS_TAB && !isClientSelectionPending) {
      return 'CLIENT'
    }
    if (displayTab === SUPPLIER_ORDERS_TAB) {
      return 'SUPPLIER'
    }
    return null
  }

  const orderType = getOrderType()

  return (
    <section className={cn.profile}>
      {isClientSelectionPending && (
        <div className={cn.clientSelectionWarning}>
          Выберите клиента для просмотра заказов клиентов
        </div>
      )}

      <div className={cn.tabs}>
        <AtomSwitch
          options={tabOptions}
          value={displayTab}
          onChange={setCurrentTab}
          ariaLabel="Заказы"
          isOrganisationSelected={isOrganisationSelected}
        />
      </div>

      <div className={cn.content}>
        {orderType && <Orders key={orderType} orderType={orderType} />}
      </div>
    </section>
  )
}

export default Profile
